import { useEffect, useRef } from "react";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

export default function RegistrationForm() {
  const formRef = useRef(null);

  useEffect(() => {
    if (formRef.current) {
      // Clear any existing content
      formRef.current.innerHTML = "";

      // Create and inject the Ontraport script
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = "https://app.ontraport.com/js/ontraport/opt_assets/drivers/opf.js";
      script.setAttribute("data-opf-uid", "p2c260712f73");
      script.setAttribute("data-opf-params", "borderColor=#000000&borderSize=0px&embed=true&formHeight=359&formWidth=100%&popPosition=mc&instance=n1822955730");
      formRef.current.appendChild(script);
    }
  }, []);

  return (
    <section
      id="register"
      data-testid="registration-section"
      className="py-24 md:py-32 bg-secondary/20"
    >
      <div className="max-w-2xl mx-auto px-6 md:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-primary mb-4 block font-['Outfit']">
            Space is Limited
          </span>
          <h2 className="text-3xl md:text-5xl font-light tracking-tight mb-4">
            Reserve Your Spot
          </h2>
          <p className="text-base font-['Outfit'] font-light text-muted-foreground">
            This is a complimentary event. Registration is requested as space is limited.
          </p>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <div
            ref={formRef}
            data-testid="ontraport-form"
            className="min-h-[360px]"
          />
        </motion.div>
      </div>
    </section>
  );
}
